module.exports = "/static/assets/d57fa1b2d6cb01b2c7e55aacb679aa67.png";